import { makeStyles, mergeClasses } from '@griffel/react';
export const carouselSliderClassNames = {
    root: 'fui-CarouselSlider'
};
/**
 * Styles for the root slot
 */ const useStyles = makeStyles({
    root: {
        display: 'flex',
        overflowAnchor: 'none'
    }
});
/**
 * Apply styling to the CarouselSlider slots based on the state
 */ export const useCarouselSliderStyles_unstable = (state)=>{
    'use no memo';
    const styles = useStyles();
    state.root.className = mergeClasses(carouselSliderClassNames.root, styles.root, state.root.className);
    return state;
};
